import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../utils/api';

const RFQWorkflowNew = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [starting, setStarting] = useState(true);

  useEffect(() => {
    const startWorkflow = async () => {
      try {
        const response = await apiClient.post('/api/rfq-workflow/start', {
          workflow_id: 25
        });

        if (response && response.run_id) {
          navigate(`/rfq-workflow/run/${response.run_id}`, { replace: true });
        } else {
          setError('Failed to start workflow - no run_id returned');
          setStarting(false);
        }
      } catch (err) {
        console.error('Error starting RFQ workflow:', err);
        setError(err.message || 'Failed to start workflow');
        setStarting(false);
      }
    };

    startWorkflow();
  }, [navigate]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px]">
        <div className="text-red-500 mb-4">{error}</div>
        <button
          onClick={() => navigate('/rfq-workflow')}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
      <p className="text-gray-600">Starting new RFQ workflow...</p>
    </div>
  );
};

export default RFQWorkflowNew;
